import CsSpace from "./space.vue";
export default CsSpace;
